import React from 'react';
import { Link } from 'react-router-dom';
import { NAV } from '@/constants/testIds';

/**
 * ClubMark: the official Tollygunge Club crest.
 * variant 'default' — white background context (header)
 * variant 'onGreen' — green background context (footer) with a white circle behind
 *   the crest so it remains crisp against the dark green.
 */
export function ClubMark({ className = '', variant = 'default' }) {
  const textColor = variant === 'onGreen' ? 'text-white' : 'text-[#1E3A2F]';
  const subColor = variant === 'onGreen' ? 'text-white/70' : 'text-[#3E4A44]';
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className={`flex-none w-10 h-10 flex items-center justify-center ${variant === 'onGreen' ? 'bg-white rounded-full p-0.5' : ''}`}
        aria-hidden="true"
      >
        <img
          src="/images/tolly-crest-160.png"
          alt=""
          width={40}
          height={40}
          className="w-10 h-10 object-contain"
          loading="eager"
          decoding="async"
        />
      </div>
      <div className="leading-tight">
        <div className={`font-extrabold text-[15px] ${textColor}`}>Tollygunge Club</div>
        <div className={`text-[11px] font-semibold ${subColor}`}>Equestrian Centre</div>
      </div>
    </div>
  );
}

export function Header() {
  return (
    <header data-testid={NAV.header} className="sticky top-0 z-40 border-b border-border bg-white">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid={NAV.headerLogo} className="outline-none" aria-label="Tollygunge Club Equestrian Centre — home">
          <ClubMark />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <a data-testid={NAV.headerBenefitsLink} href="#benefits" className="text-sm font-semibold text-[#3E4A44] hover:text-[#1E3A2F] hidden sm:inline px-3 py-2 rounded-lg">What's included</a>
          <a data-testid={NAV.headerGridLink} href="#the-herd" className="text-sm font-semibold text-[#3E4A44] hover:text-[#1E3A2F] px-3 py-2 rounded-lg">Meet the horses</a>
        </nav>
      </div>
    </header>
  );
}

export function Footer({ address, established }) {
  return (
    <footer data-testid={NAV.footer} className="bg-[#1E3A2F] text-white mt-16">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-10 grid gap-8 sm:grid-cols-2">
        <div>
          <ClubMark variant="onGreen" />
          <p className="text-sm text-white/70 mt-4 max-w-sm leading-relaxed">
            {address || 'Tollygunge Club Ltd · 120, Deshapran Sasmal Road, Kolkata 700033'}<br/>
            {established || 'Established 1895'}
          </p>
        </div>
        <div className="sm:text-right text-sm text-white/80 space-y-2 leading-relaxed">
          <p>Equestrian Centre · Stable Office</p>
          <p>By appointment only · Members and their guests</p>
          <p className="pt-2">
            <Link data-testid={NAV.adminLoginLink} to="/admin/login" className="text-white underline underline-offset-4 hover:opacity-80 font-semibold">Stable Office login</Link>
          </p>
          <p className="pt-2 text-xs text-white/60">We only store the details you submit via the sponsorship enquiry form.</p>
        </div>
      </div>
    </footer>
  );
}
